import { useState, type InputHTMLAttributes } from "react";

/** Oculta el cero al enfocar sin cambiar el dato hasta que se escribe. */
export function EntradaNumero({ value, onFocus, onBlur, onChange, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const [vacio, setVacio] = useState(false);
  return <input {...props} type="number" value={vacio && Number(value) === 0 ? "" : value}
    onFocus={e => { if (value !== "" && Number(value) === 0) setVacio(true); onFocus?.(e); }}
    onChange={e => { setVacio(e.currentTarget.value === ""); onChange?.(e); }}
    onBlur={e => { setVacio(false); onBlur?.(e); }} />;
}
